import { Modal } from "antd";
import { faMapLocation } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";

//ASSETS
import iconTalhao from '../../../../assets/img/iconTalhao.svg';
import iconTalhaoSubArea from '../../../../assets/img/iconSubArea.svg';

//STYLES
import { ContainerDashboard } from "./style";

//APP
import { localConfig } from "../../../../Configs/localConfig";
import { talhoesFinalizados } from "./meta/dados_modais";
import { useGetEquipeCliente } from "../../../../services/Equipe/GET";
import { detalhamentos, insumos, patrimonios, prazos, progressoGeral, progressoTalhoes } from "./meta/obter_dados";
import { useGetAtividadesPorTalhao, useGetPropriedadesDoCliente, useGetUnidadesDeMedidas } from "../../../../services/atividades/GET";

//COMPONENTS
import Carregando from "../../../../Components/CustomUi/loading";
import { Prazos } from "./components/prazos";
import { Insumos } from "./components/insumos";
import { Talhoes } from "./components/talhoes";
import { Execucoes } from "./components/modais/execucoes";
import { PopSelect } from "../../../../Components/CustomUi/PopSelect";
import { Patrimonios } from "./components/patrimonios";
import { TalhoesCard } from "./components/modais/talhoes";
import { Detalhamento } from "./components/detalhamento";
import { ProgressoGeral } from "./components/progressoGeral";
import { TalhoesPlanejadas } from "./components/modais/planejadas";
import { TalhoesFinalizados } from "./components/modais/talhoesFinalizados";

export const VisaoGeralAtv: React.FC = () => {

    //CONST
    const { codSafra } = localConfig();

    //#region STATES
    //PROPRIEDADE
    const [nome_propriedade_selecionada, setNome_propriedade_selecionada] = useState<string>('');
    const [cod_propriedade_selecionada, setCod_propriedade_selecionada] = useState<number>(null);
    //TALHÃO
    const [lista_talhoes, setLista_talhoes] = useState<any[]>([]);
    const [nome_talhao_selecionado, setNome_talhao_selecionado] = useState<string>('');
    const [cod_talhao_selecionado, setCod_talhao_selecionado] = useState<number>(null);
    const [area_talhao_selecionado, setArea_talhao_selecionado] = useState<string>('');
    //SUBAÁREA
    const [nome_subarea_selecionada, setNome_subarea_selecionada] = useState<string>('');
    const [cod_subarea_selecionada, setCod_subarea_selecionada] = useState<number>(null);
    const [area_subarea_selecionada, setArea_subarea_selecionada] = useState<string>('');
    //MODAIS
    const [open_talhoes, setOpen_talhoes] = useState<boolean>(false);
    const [open_talhoes_finalizados, setOpen_talhoes_finalizados] = useState<boolean>(false);
    const [open_execucoes, setOpen_execucoes] = useState<boolean>(false);
    const [open_planejadas, setOpen_planejadas] = useState<boolean>(false);

    //#region API
    const { data_equipe_cliente } = useGetEquipeCliente(); //lista equipe
    const { data_unidades_medida } = useGetUnidadesDeMedidas();
    const { data_propriedades, carregando_propriedades } = useGetPropriedadesDoCliente();
    const { data_atividades, carregando_atividades } = useGetAtividadesPorTalhao(cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada, true, 600000000);

    const todas_atividades_ativas = (data_atividades ?? []).filter(i => i.delete_time === null);

    useEffect(() => {
        setCod_talhao_selecionado(null);
        setCod_subarea_selecionada(null);
        setNome_talhao_selecionado('');
        setNome_subarea_selecionada('');
        /**obtem a lista de talhões da propriedade selecionada */
        if ((data_propriedades ?? []).length > 0) {
            let propriedade_selecionada = (data_propriedades ?? []).filter(i => i?.cod === cod_propriedade_selecionada);
            setLista_talhoes(propriedade_selecionada?.[0]?.talhao ?? []);
        }
    }, [cod_propriedade_selecionada]);

    useEffect(() => {
        setCod_subarea_selecionada(null);
        setNome_subarea_selecionada('');
    }, [cod_talhao_selecionado]);

    return (
        <ContainerDashboard>
            <div className="Dashboard__filter">
                <div style={{ width: '100%', display: 'flex', gap: 15, alignItems: 'center' }}>
                    <PopSelect
                        label="Selecione a propriedade"
                        empty_placeholder="Nenhuma foi selecionada"
                        icon={faMapLocation}
                        value={nome_propriedade_selecionada}
                        onChange={setNome_propriedade_selecionada}
                        onChangeId={setCod_propriedade_selecionada}
                        items={data_propriedades ?? []}
                        descricaoItem="nome"
                        idItem="cod"
                        loading={carregando_propriedades}
                        zIndex={10}
                    />
                    <PopSelect
                        label="Selecione o talhão"
                        empty_placeholder="Nenhum foi selecionado"
                        icon={iconTalhao}
                        value={nome_talhao_selecionado}
                        onChange={setNome_talhao_selecionado}
                        onChangeId={setCod_talhao_selecionado}
                        onChangeExtra={setArea_talhao_selecionado}
                        items={(lista_talhoes ?? []).filter(i => i?.cod_safra == codSafra && i.cod_talhao === null) ?? []}
                        iconList={["kml", "coordenadas"]}
                        descricaoItem="nome"
                        idItem="cod"
                        extraItem='area'
                        disabled={cod_propriedade_selecionada === null}
                        zIndex={9}
                    />
                    <PopSelect
                        label="Subarea"
                        empty_placeholder="Nenhuma foi selecionada"
                        icon={iconTalhaoSubArea}
                        value={nome_subarea_selecionada}
                        onChange={setNome_subarea_selecionada}
                        onChangeId={setCod_subarea_selecionada}
                        onChangeExtra={setArea_subarea_selecionada}
                        items={(lista_talhoes ?? []).filter(i => i?.cod_safra !== null && i.cod_talhao === cod_talhao_selecionado) ?? []}
                        iconList={["kml", "coordenadas"]}
                        descricaoItem="nome"
                        idItem="cod"
                        extraItem='area'
                        disabled={cod_talhao_selecionado === null}
                        zIndex={8}
                    />

                </div>

            </div>

            {(carregando_atividades || carregando_propriedades)
                ?
                <Carregando
                    animation
                    legenda="Analisando dados das atividades..."
                    justifyContent="center"
                    height={400}
                />
                :
                <>
                    <div className="Dashboard__progress">
                        <ProgressoGeral
                            dados_progresso={progressoGeral(todas_atividades_ativas, data_propriedades, cod_propriedade_selecionada, cod_talhao_selecionado) ?? []}
                        />

                        <Prazos
                            dados_prazo={prazos(todas_atividades_ativas)?.porcentagens}
                            qtd_prazos={prazos(todas_atividades_ativas)?.quantidades}
                        />

                        <Detalhamento
                            dados_detalhamento={detalhamentos(todas_atividades_ativas, data_propriedades, cod_propriedade_selecionada, cod_talhao_selecionado) ?? null}
                            setOpen_talhoes_finalizados={setOpen_talhoes_finalizados}
                            setOpen_talhoes={setOpen_talhoes}
                            setOpen_execucoes={setOpen_execucoes}
                            setOpen_planejadas={setOpen_planejadas}
                        />
                    </div>

                    <div className="Dashboard__three">
                        <Talhoes
                            title={cod_propriedade_selecionada ? 'Talhões' : 'Propriedades'}
                            placeholder={cod_propriedade_selecionada ? 'Buscar talhão' : 'Buscar propriedade'}
                            dados_talhoes={progressoTalhoes(todas_atividades_ativas, data_propriedades, cod_propriedade_selecionada, cod_talhao_selecionado)}
                            data_atividades={todas_atividades_ativas}
                            cod_propriedade={cod_propriedade_selecionada}
                            data_propriedades={data_propriedades}
                            cod_talhao={cod_talhao_selecionado}
                            data_equipe_cliente={data_equipe_cliente}
                        />

                        <Insumos
                            dados_insumos_executadas={insumos(todas_atividades_ativas, data_unidades_medida, 'executada')}
                            dados_insumos_planejada={insumos(todas_atividades_ativas, data_unidades_medida, 'planejada')}
                            data_atividades={todas_atividades_ativas}
                            data_unidades_medida={data_unidades_medida}
                            data_propriedades={data_propriedades}
                            data_equipe_cliente={data_equipe_cliente}
                        />

                        <Patrimonios
                            dados_patrimonios={patrimonios(todas_atividades_ativas)}
                            data_atividades={todas_atividades_ativas}
                            data_propriedades={data_propriedades}
                        />
                    </div>
                </>
            }

            <Modal
                open={open_talhoes}
                onCancel={() => { setOpen_talhoes(false) }}
                title="Talhões"
                footer={false}
                width={960}
                destroyOnClose
            >
                <TalhoesCard
                    data_equipe_cliente={data_equipe_cliente}
                    lista_talhoes_finalizados={talhoesFinalizados(todas_atividades_ativas, data_propriedades).talhoes}
                    cod_propriedade_selecionada={cod_propriedade_selecionada}
                    cod_talhao_selecionado={cod_talhao_selecionado}
                />
            </Modal>

            <Modal
                open={open_talhoes_finalizados}
                onCancel={() => { setOpen_talhoes_finalizados(false) }}
                title="Talhões finalizados"
                footer={false}
                width={960}
                destroyOnClose
            >
                <TalhoesFinalizados
                    data_equipe_cliente={data_equipe_cliente}
                    lista_talhoes_finalizados={talhoesFinalizados(todas_atividades_ativas, data_propriedades).finalizados}
                />
            </Modal>

            <Modal
                open={open_execucoes}
                onCancel={() => { setOpen_execucoes(false) }}
                title="Execuções"
                footer={false}
                width={960}
                destroyOnClose
            >
                <Execucoes
                    data_equipe_cliente={data_equipe_cliente}
                    lista_talhoes_finalizados={talhoesFinalizados(todas_atividades_ativas, data_propriedades).talhoes}
                />
            </Modal>

            <Modal
                open={open_planejadas}
                onCancel={() => { setOpen_planejadas(false) }}
                title="Atividades planejadas"
                footer={false}
                width={960}
                destroyOnClose
            >
                <TalhoesPlanejadas
                    data_equipe_cliente={data_equipe_cliente}
                    lista_talhoes_finalizados={talhoesFinalizados(todas_atividades_ativas, data_propriedades).talhoes}
                    cod_propriedade_selecionada={cod_propriedade_selecionada}
                    cod_talhao_selecionado={cod_talhao_selecionado}
                />
            </Modal>

        </ContainerDashboard>
    )
}